// extracted by mini-css-extract-plugin
module.exports = {"section":"style_section__ms4Ju","textContainer":"style_textContainer__2Q_Zf","text":"style_text__3ZTdO"};